import { Navigate, Outlet, Route } from "react-location";

import {
    CogIcon,
    DocumentTextIcon,
    FolderIcon,
    HomeIcon,
    ShieldCheckIcon,
    XCircleIcon,
} from "@heroicons/react/24/outline";
import PusherConnectionTest from "components/test/PusherConnectionTest";
import AllBusinesses from "pages/AllBusiness";
import {
    AllTreatiesPage,
    CancelledOffersPage,
    ClaimsPage,
    ClosedOffersPage,
    DashboardPage,
    ForgotPasswordPage,
    HoldOffersPage,
    LoginPage,
    ReportsPage,
    ResetPasswordPage,
    SettingsPage,
} from "../pages";

export type SidebarSection = "Offers" | "Operations" | "Config";

export type RouteProps = Omit<Route, "children" | "meta"> & {
    // withPermissions?: UserPermission[];
    navigation?: boolean;
    sidebar?: { label: string; icon: any };
    meta?: {
        layout?: "App" | "Auth";
        breadcrumb?: () => string;
        section?: SidebarSection | "General";
    };
    children?: RouteProps[];
};

const routes: RouteProps[] = [
    {
        path: "/app/dashboard",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.dashboard",
            icon: HomeIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "Dashboard",
            section: "Offers",
        },
        children: [
            {
                path: "/",
                element: <DashboardPage />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "app/businesses",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.published_offers",
            icon: FolderIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "Published Offers",
            section: "Offers",
        },
        children: [
            {
                path: "/",
                element: <AllBusinesses />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
            {
                path: "/test",
                element: <PusherConnectionTest />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "app/offers",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.closed_offers",
            icon: FolderIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "Closed Offers",
            section: "Offers",
        },
        children: [
            {
                path: "/",
                element: <ClosedOffersPage />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "app/cancelled-offers",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.cancelled_offers",
            icon: XCircleIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "Cancelled Offers",
            section: "Offers",
        },
        children: [
            {
                path: "/",
                element: <CancelledOffersPage />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "app/hold-cover",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.hold_cover",
            icon: ShieldCheckIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "hold-cover",
            section: "Operations",
        },
        children: [
            {
                path: "/",
                element: <HoldOffersPage />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "app/claims",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.claims",
            icon: DocumentTextIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "Claims",
            section: "Operations",
        },
        children: [
            {
                path: "/",
                element: <ClaimsPage />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "app/treaties",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.all_treaties",
            icon: FolderIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "All Treaties",
            section: "Operations",
        },
        children: [
            {
                path: "/",
                element: <AllTreatiesPage />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "app/reports",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.reports",
            icon: FolderIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "Reports",
            section: "Config",
        },
        children: [
            {
                path: "/",
                element: <ReportsPage />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "app/settings",
        element: <Outlet />,
        sidebar: {
            label: "sidebar.settings",
            icon: CogIcon,
        },
        meta: {
            layout: "App",
            breadcrumb: () => "Settings",
            section: "Config",
        },
        children: [
            {
                path: "/",
                element: <SettingsPage />,
                meta: {
                    layout: "App",
                    section: "General",
                },
            },
        ],
    },
    {
        path: "/",
        element: <Navigate to="/cpanel-login" />,
        meta: {
            layout: "Auth",
            breadcrumb: () => "Auth",
        },
    },
    {
        path: "cpanel-login",
        element: <LoginPage />,
        meta: {
            layout: "Auth",
            breadcrumb: () => "Auth",
        },
    },
    {
        path: "forgot-password",
        element: <ForgotPasswordPage />,
        meta: {
            layout: "Auth",
            breadcrumb: () => "Forgot Password",
        },
    },
    {
        path: "reset-password",
        element: <ResetPasswordPage />,
        meta: {
            layout: "Auth",
            breadcrumb: () => "Reset Password",
        },
    },
];

export default routes;
